import { TaskModel } from "./TaskModel";

export class OrderTaskModel extends TaskModel {
  /**Возможность формировать очередность */
  ChangeAccess: boolean = false;
  /**Админ в задаче (либо админ проекта, либо админ раб. области) */
  IsAdmin: boolean = false;
  /**Есть ли минимальный доступ к задаче (если пользователь может ее открыть) */
  HasAccessToTask: boolean = false;

  constructor(obj?: Partial<OrderTaskModel>) {
    super(obj);
    Object.assign(this, obj);
  }
}
